'use strict';

import ready from './ready';
import debounce from './debounce';

ready().then(function () {
    const debouncedUpdate = debounce(function () {
        document.body.style.setProperty(
            '--scrollbar-width',
            Math.min(window.innerWidth, window.screen.width) - document.documentElement.clientWidth + 'px'
        );
    });
    debouncedUpdate();
    window.addEventListener('resize', debouncedUpdate, {passive: true});
});